<div
  class="search-info-bar toolbar-h w-100 d-flex align-items-center justify-content-around"
>
  @if (filtersNumber || filtersNumber === 0) {
    <span class="mr-5 d-flex">
      <mat-icon>search</mat-icon>{{ 'rechercheMenu.filter' | translate }}:
      {{ filtersNumber }}
    </span>
  }
  @if (resultsNumber || resultsNumber === 0) {
    <span class="d-flex">
      <mat-icon>check_circle_outline</mat-icon>
      {{ 'rechercheMenu.find' | translate }}: {{ resultsNumber }}
    </span>
  }
  @if (notFoundNumber || notFoundNumber === 0) {
    <span class="d-flex">
      <mat-icon>highlight_off</mat-icon>{{ 'rechercheMenu.notFind' | translate }}:
      {{ notFoundNumber }}
    </span>
  }
</div>
